import { APP_ID, inject, Injectable } from '@angular/core';
import { LinkField } from '@prismicio/client';
import { Product, ProductService } from 'product-shared';
import { Promotion } from 'promotion-shared';
import { TranslateService } from 'translate';
import { App, createLinkFromString } from 'utils';

@Injectable({ providedIn: 'root' })
export class ProductBoxCtaConfigService {
  private productService = inject(ProductService);
  private appId = inject(APP_ID, { optional: true });

  public getCtaLink(
    product: Product,
    promotion: Promotion | null,
    lightMode: boolean,
    typeOfPageShownOn: string,
    ctaCustomLink: LinkField | undefined,
    lineCheckId: string | undefined
  ): { link: LinkField; queryParams?: object } {
    const { special_product_type, alternative_link, product_type, product_details_link } = product;
    const hfcOrFiber = ['hfc', 'fiber'].includes(product_type);
    const hfcOrFiberInsideNavigation = hfcOrFiber && lightMode;
    const hfcOrFiberInsideLineCheckResults = hfcOrFiber && !!typeOfPageShownOn;
    const anyProductInsideSpecialDetailPageResults = typeOfPageShownOn === 'special product detail page';
    const specialProductInsideHomePageLineCheckResults = special_product_type && typeOfPageShownOn === 'home page'; // HOME MAX, HOME MAX TV

    if (ctaCustomLink) {
      return { link: ctaCustomLink };
    }

    if (hfcOrFiberInsideNavigation) {
      return { link: product_details_link };
    }

    if (
      this.appId === App.website &&
      (specialProductInsideHomePageLineCheckResults ||
        (alternative_link && !(hfcOrFiberInsideLineCheckResults || anyProductInsideSpecialDetailPageResults)))
    ) {
      return { link: createLinkFromString(alternative_link) };
    }
    // Default checkout path logic

    return this.productService.buildCheckoutPath(product, promotion, lineCheckId);
  }

  public getCtaStyling(
    product: Product,
    promotion: Promotion | null,
    lightMode: boolean,
    hasDiscountedCost: boolean,
    ctaCustomLabel: string,
    ctaCustomClasses: string,
    translateService: TranslateService
  ): { label: string; classes: string } {
    let label: string;
    if (ctaCustomLabel) {
      label = ctaCustomLabel;
    } else if ((product.product_type === 'hfc' || product.product_type === 'fiber') && lightMode) {
      label = product.product_details_link_label;
    } else {
      label = product.cta_button_label || translateService.getTranslation(['checkoutButton']);
    }

    const classes = ctaCustomClasses || (promotion && hasDiscountedCost ? 'featured pulse' : '');

    return { label, classes };
  }
}
